import { render, staticRenderFns } from "./PrintVariants.vue?vue&type=template&id=f8d98184&scoped=true"
import script from "./PrintVariants.vue?vue&type=script&lang=js"
export * from "./PrintVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d98184",
  null
  
)

export default component.exports